// useNavigateErrorHandler.js
import { useNavigate } from 'react-router-dom';
import { useSnackbar } from 'src/components/snackbar';

const useNavigateErrorHandler = () => {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  const handleApiError = (error) => {
    // Debug log to see if the error is arriving already marked
    console.log('[useNavigateErrorHandler] Checking error handled status:', error?._handled);

    // ✅ Skip navigation if the error was already handled centrally (e.g. by axios interceptor snackbar)
    if (error?._handled) {
      console.log('[useNavigateErrorHandler] Error already handled. Skipping navigation.');
      return; 
    }

    const errorResponse = error?.response || {};
    const { status, data } = errorResponse;

    const errorCode = data?.errorCode || 'Unknown Error';
    const errorMessage =
      (typeof data === 'string' ? data : data?.message || data?.error || data?.errorMessage) ||
      error?.message ||
      'An unexpected error occurred.';
    const statusCode = status || 'N/A';
    const errorType = data?.type || 'N/A';
    const timestamp = data?.timestamp || new Date().toISOString();

    // ✅ Handle 409 Conflict (e.g., Duplicate values found for: Mobile Number)
    // Display snackbar on the current form instead of navigating to the error page
    if (status === 409) {
      console.log('[useNavigateErrorHandler] Status 409 (Conflict) detected. Displaying snackbar.');
      enqueueSnackbar(errorMessage || 'Duplicate entry found.', { variant: 'error' });
      return;
    }

    console.log('[useNavigateErrorHandler] Proceeding to navigate to /error-page. Status:', status);

    // Navigate to the error page only for truly unhandled/critical errors
    navigate('/error-page', {
      state: { errorCode, message: errorMessage, statusCode, type: errorType, timestamp },
    });
  };

  return handleApiError;
};

export default useNavigateErrorHandler;
